import Dexie from "dexie";

export const db = new Dexie("OfflineDB");

db.version(1).stores({
  products: "_id, syncupdatedAt",
  customers: "_id, syncupdatedAt",
//   sales: "id, syncStatus"
});
